export default __webpack_public_path__ + "static/media/livestream_optimized.45c0187f.png";